import { AIAskResultsPage } from '@/components/GlobalSearch/AIAsk/components/results/ResultsPage';
import { RouteRestrictions } from '@/utilities';
import { restrictedRoute } from '@/utilities/restrictedRoute';

export default restrictedRoute(AIAskResultsPage, {
  requiresEvery: [
    RouteRestrictions.AUTHENTICATION,
    RouteRestrictions.COMMUNITY_ACCESS,
  ],
});
